export default __webpack_public_path__ + "static/media/ae1fa4335ee0767de68ab7d91a6e61dc.svg";